<template>
    <div class="channel-lineup-preview" :class="{loading: loading}">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4>{{feature.title}}</h4><br>
                    <h5>Channel Lineup</h5>

                    <a href="javascript://void" class="back" @click="closeModal">Back</a>
                </header>

                <div class="row">
                    <div class="col-sm-6" v-for="channels in chunkedData">
                        <ul class="list-unstyled">
                            <li v-for="channel in channels" class="margin-sm-bottom">
                                {{channel}}
                            </li>
                        </ul>
                    </div>
                </div>

                <div v-if="canEdit">
                    <hr>

                    <a :href="'/features/' + featureId">Edit</a>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            featureId: {
                type: String,
                required: true,
                default(){
                    return null;
                }
            },

            modalId: {
                default(){
                    return Math.random().toString();
                },
                type: String
            },

            canEdit: {
                type: Boolean,
                default: false
            }
        },

        data(){
            return {
                feature: {},

                file: null,
                loading: false,
            };
        },

        created: function(){
            this.init();
        },

        computed: {
            chunkedData(){
                if( this.feature.data && this.feature.data.length > 1 ){
                    return _.chunk( this.feature.data, _.floor( this.feature.data.length / 2 ) );
                }

                return [];
            }
        },

        methods: {
            init(){
                this.loading = true;

                return this.loadFeature()
                    .catch( this.$root.handleErrors )
                    .finally( () => {
                        this.loading = false;
                    } );
            },

            loadFeature(){
                var url = '/api/features/' + this.featureId;

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'feature', response.data.Feature );
                    } );
            },

            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            },
        }
    }
</script>